<template>
  <div class="guardian-dashboard" v-if="isCardActiveLocal" ref="whole_page">
    <div class="vx-row mb-2" style="justify-content: space-between;">
      <div class="vx-col mb-2 w-100" style="align-items: center;">
        <div class="vx-row ml-1 sort-area">
          <div class="vx-col">
            <div class="vx-row">
              <span><feather-icon class="mr-3" icon="SlidersIcon" svg-classes="stroke-current h-8 w-8"></feather-icon></span>
              <h4 style="margin-bottom: 0;" class="mr-4">Sort By</h4>
            </div>
          </div>
          <div class="vx-col">
            <vx-input-group class="input-group-with-dropdown-for-filtering " style="">
              <template slot="prepend">
                <div class="prepend-text ">
                  <span><feather-icon class="pt-1" icon="BookOpenIcon" svg-classes="stroke-current h-5 w-5"></feather-icon></span>
                </div>
              </template>

              <v-select
                ref="schoolDropdown"
                class=" style-chooser filter-dropdown"
                placeholder="All Grades"
                :options="grades"
                @search:blur="selectGrade"
                v-model="gradeDropdown"
                @input="clearGradeFilter"
                :class="studentsLoading ? 'disabled' : ''"
              />
            </vx-input-group>
          </div>
          <div class="vx-col">
              <vx-input-group class="input-group-with-input-for-filtering " style="">
                <template slot="prepend">
                  <div class="prepend-text ">
                    <span><feather-icon class="pt-1" icon="SearchIcon" svg-classes="stroke-current h-5 w-5"></feather-icon></span>
                  </div>
                </template>

                <vs-input :class="studentsLoading ? 'disabled' : ''" class="dashboard-filter-input" placeholder="Search here..." v-model="studentFilterText"/>
              </vx-input-group>
            </div>
        </div>
      </div>
      
    </div>

    <div class="vx-row" v-if="students.length == 0 && !studentsLoading">
      <div class="vx-col mb-2 mx-auto">
        <h4>No results to display</h4>
      </div>
    </div>

    <div v-if="!studentsLoading" class="vx-row student-list-container">
      <div class="vx-col mb-2" style="width: 200px" v-for="(student, index) in students" :key="index">
        <vx-card @click="selectedStudent(student)" style="border-radius: 90px 90px 30px 30px;" class="clickable--card">
          <div slot="no-body">
            <img id="studentprofilepic" style="display:none" :class="`student-profile-pic-${index}`" @load="imageloaded(index)" :src="student.profilePicUrl" alt="content-img" class="responsive card-img-top" />
            <custom-skeleton :class="`student-profile-loader-${index}`" style="padding: 6px;" class="responsive card-img-top" animation="wave" type="avatar" :count="1" height="160px" width="160px"></custom-skeleton>
          </div>
          <h5>{{student.name}}</h5>
        </vx-card>
      </div>
    </div>

    <div v-if="studentsLoading">
      <user-skeleton :count="4"></user-skeleton>
    </div>

    <line-chart :isLoading="chartLoadingTimeSpent" :series="timeSpentSeries" :title="'Time Spent'" :filterList="listOfStudentsForDropdown" @filterDropdownChanged="filterDropdownChangedStudentGraphTimeSpent"/>
    <line-chart :isLoading="chartLoadingGraphScore" :series="scoreSeries" :title="'Score'" :filterList="listOfStudentsForDropdown" @filterDropdownChanged="filterDropdownChangedStudentGraphScore"/>
    
  </div>
</template>


<script>
import VueApexCharts from 'vue-apexcharts'
import vSelect from 'vue-select'
import LineChart from './LineChart.vue';
import UserSkeleton from './UserSkeleton.vue';
import CustomSkeleton from './CustomSkeleton.vue'

export default {
  name: "Students",
  components: {
    VueApexCharts,
    vSelect,
    LineChart,
    UserSkeleton,
    CustomSkeleton
  },
  props: {
    isCardActive: {
      type: Boolean,
      required: true
    },
  },
  data() {
    return {
      students: [],
      originalStudents: [],
      grades: [],
      originalGrades: [],
      gradeDropdown: null,
      studentFilterText: null,
      timeSpentSeries: [],
      scoreSeries: [],
      listOfStudentsForDropdown: [],
      studentsLoading:true,
      chartLoadingTimeSpent:true,
      chartLoadingGraphScore:true,
    };
  },
  watch: {
    isCardActive: function(val) {
      if(val){
        var self = this;
        self.initValues();
      }
    },
    studentFilterText: function(val) {
      var self = this;
      if(val) {
        if (self.gradeDropdown && self.gradeDropdown.value) {
          self.students = self.originalStudents.filter(function(x) { return x.name.toLowerCase().includes(val.toLowerCase()) && x.gradeId == self.gradeDropdown.value });
        } else {
          self.students = self.originalStudents.filter(function(x) { return x.name.toLowerCase().includes(val.toLowerCase()) });
        }

        var availableGrades = self.students.map(function(x) { return x.gradeId });
        var filteredGrades = self.originalGrades.filter(function(x) { return availableGrades.includes(parseInt(x.value)) });
        self.grades = filteredGrades;
      } else {
        if (self.gradeDropdown && self.gradeDropdown.value) {
          self.selectGrade();
        } else {
          self.students = self.originalStudents;
        }
        self.grades = self.originalGrades;
      }
    }
  },
  computed: {
    isCardActiveLocal: {
      get() {
        return this.isCardActive;
      },
      set(val) { }
    },
  },
  methods: {
    initValues(){
      // this.studentsLoading = true;
    },
    getStudents() {
      var self = this;

      var onSuccess = function(response) {
        self.grades = [];
        self.students = response.data;
        self.originalStudents = self.students;

        self.listOfStudentsForDropdown = self.students.map((item) => {return { label: item.name, value: item.id }});

        self.$emit("setListOfStudents", self.listOfStudentsForDropdown);

        var tempGrades = Array.from(new Set(response.data.map(x => x.gradeId)))
            .map(value => { 
              return { 
                label: response.data.find(x => x.gradeId == value).gradeName,
                value: response.data.find(x => x.gradeId == value).gradeId
              } 
            });

        tempGrades = tempGrades.filter(function(item) { return item.label != null });
        tempGrades = tempGrades.sort((a, b) => a.label > b.label ? 1 : -1);

        self.grades.push({ label: "No Grade", value: -1 });
        self.grades = self.grades.concat(tempGrades);
        self.originalGrades = self.grades;
      };

      var onFinally = function(response) {
        self.studentsLoading = false;
        self.chartLoadingTimeSpent = false;
        self.chartLoadingGraphScore = false;
      };

      self.$ajaxGet(self, "GuardianDashboard/ListUsers", onSuccess, onFinally);
    },
    selectGrade() {
      var self = this;
      if (self.gradeDropdown && self.gradeDropdown.value) {
        if (self.studentFilterText) {
          self.students = self.originalStudents.filter(function(x) { return x.gradeId == (self.gradeDropdown.value > 0 ? self.gradeDropdown.value : null) && x.name.toLowerCase().includes(self.studentFilterText.toLowerCase()) });
        } else {
          self.students = self.originalStudents.filter(function(x) { return x.gradeId == (self.gradeDropdown.value > 0 ? self.gradeDropdown.value : null) });
        }
      }
    },
    clearGradeFilter() {
      var self = this;
      if (self.studentFilterText) {
        self.students = self.originalStudents.filter(function(x) { return x.name.toLowerCase().includes(self.studentFilterText.toLowerCase()) });
      } else {
        self.students = self.originalStudents;
      }
    },
    showLoadingOnElement(element, scale, type) {
      var self = this;
      self.$vs.loading({
        type: type,
        container: self.$refs[element].$el,
        scale: scale
      });
    },
    selectedStudent(student){
      this.$emit('selectedStudent',student)
    },
    imageloaded(index){
      var image = document.getElementsByClassName(`student-profile-pic-${index}`);
      var loader = document.getElementsByClassName(`student-profile-loader-${index}`);
      image[0].style.display = "block";
      loader[0].style.display = "none";
    },
    filterDropdownChangedStudentGraphTimeSpent(studentName,studentId,selectedDate) {
      var self = this;
      this.chartLoadingTimeSpent = true;
      var onSuccess = response =>{
        self.timeSpentSeries = [
          {
            name: "Single Student Avg.",
            data: response.data.avaragesList,
          },
          {
            name: "Combined Student Avg.",
            data: response.data.timeSpentAvaragesList
          }
        ];
      }
    
      var onFinally = response =>{
        self.chartLoadingTimeSpent = false;
      }
    
      self.$ajaxGet(self, `GuardianDashboard/StudentGraphTimeSpent?studentId=${studentId}&month=${selectedDate.monthIndex}&year=${selectedDate.year}` , onSuccess, onFinally);
    },
    filterDropdownChangedStudentGraphScore(studentName,studentId,selectedDate) {
      var self = this;
      this.chartLoadingGraphScore = true;
      var onSuccess = response =>{
        self.scoreSeries = [
          {
            name: "Single Student Avg.",
            data: response.data.scoreList,
          },
          {
            name: "Combined Student Avg.",
            data: response.data.scoreListAvg,
          },
        ];
      }
    
      var onFinally = response =>{
        self.chartLoadingGraphScore = false;
      }
    
      self.$ajaxGet(self, `GuardianDashboard/StudentGraphScore?studentId=${studentId}&month=${selectedDate.monthIndex}&year=${selectedDate.year}` , onSuccess, onFinally);
    }
  },
  created() {
  },
  mounted() {
    var self = this;
    self.$emit("updateBreadcrumbs", "add", { text: "Students", clickFunction: "backToStudents", icon: "UsersIcon" });
    self.getStudents();
  }
};
</script>

<style lang="scss">
  //prototype
  #studentprofilepic {
    border-radius: 50%;
    padding: 6px;
    // border:1px solid #838383;
    background-color: #10163a;
  }
  
  .guardian-dashboard{
    .v-select.disabled .open-indicator{
      background: unset;
      pointer-events: none;
    }
    .v-select.disabled .dropdown-toggle input{
      background: unset;
      pointer-events: none;
    }
  }

  @media screen and(max-width:837px){
    .student-list-container{
      justify-content: center;
    }
  }

  @media screen and(max-width:1022px){
    .sort-area{
      &:last-child{
        .vx-col{
          margin-top: 10px;

        }
      }
    }
  }
  @media screen and(min-width:1022px){
    .sort-area{
      .vx-col:last-child{
        margin-left: auto;
      }
    }
  }

  @media screen and(max-width:414px){
    .sort-area{
      justify-content: center;
    }
  }

  

</style>
